export default __webpack_public_path__ + "static/media/basket.267ff5f7.webp";